import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { User as CommonUser } from '../../../../../common/types/user-info';
import { RootState } from '../../../../init-store/index';

interface ToPassportArgs {
    url?: string;
    retpath?: string;
    backpath?: string;
}

export const toPassport = createAction<ToPassportArgs | undefined>('@USER/TO_PASSPORT');
export const toSsoPassport = createAction<{ login: string }>('@USER/TO_SSO_PASSPORT');

export type User = CommonUser;
const userSlice = createSlice({
    name: '@USER',
    initialState: null as User | null,
    reducers: {
        setUser: (state, action: PayloadAction<User | null>) => {
            if (!action.payload) {
                return action.payload;
            }
            state = Object.assign(state || {}, action.payload);
            return state;
        },

        updateUser: (state, action: PayloadAction<Partial<User> | null>) => {
            const user = action.payload;
            if (user && state) {
                if (user.name) {
                    state.name = user.name;
                }
                if (user.displayName) {
                    state.displayName = user.displayName;
                }
                if (user.avatarUrl) {
                    state.avatarUrl = user.avatarUrl;
                }
                if (user.avatarPlaceholder) {
                    state.avatarPlaceholder = user.avatarPlaceholder;
                }
            }

            return state;
        },
    },
});

export const { setUser, updateUser } = userSlice.actions;

export const userReducer = userSlice.reducer;

export const getUserSelector = (state: RootState) => state.user;
